import React, { useState, useEffect, useRef, useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";
import { motion } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { CardEvent } from "../../";
import { mediaQueries } from "../../../constant";
import { iconChevron } from "../../../assets/images";
import styles from "./styles.module.scss";

export default function SliderSlickJourney({ data, classCustom, showElement }) {
  const refImage = useRef();
  const refContent = useRef();
  const [elTopImage, setElTopImage] = useState(0);
  const [elTopContent, setElTopContent] = useState(0);
  const [showElImage, setShowElImage] = useState(false);
  const [showElContent, setShowElContent] = useState(false);
  const [startingPoint, setStartingPoint] = useState(0);
  const isBiggerScreen = useMediaQuery({
    query: `(min-device-width: ${mediaQueries?.tablet}px)`,
  });

  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: 0.3,
        },
      },
    }),
    []
  );

  const variantDots = useMemo(
    () => ({
      offScreen: { y: -100, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1,
        },
      },
    }),
    []
  );
  const variantImage = useMemo(
    () => ({
      offScreen: { x: -100, opacity: 0 },
      onScreen: {
        x: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1,
          delay: 0.5,
        },
      },
    }),
    []
  );

  const variantContent = useMemo(
    () => ({
      offScreen: {
        x: isBiggerScreen ? 100 : 0,
        y: isBiggerScreen ? 0 : 100,
        opacity: 0,
      },
      onScreen: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1,
          delay: 0.25,
        },
      },
    }),
    [isBiggerScreen]
  );

  const checkScrollCondition = () => {
    if (
      window.pageYOffset > 0 &&
      elTopImage > 0 &&
      window.pageYOffset + startingPoint > elTopImage
    ) {
      setShowElImage(true);
    } else {
      setShowElImage(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopContent > 0 &&
      window.pageYOffset + startingPoint > elTopContent
    ) {
      setShowElContent(true);
    } else {
      setShowElContent(false);
    }
  };

  useEffect(() => {
    const setValues = () => {
      setStartingPoint(window.innerHeight * 0.85);
      if (refImage.current) setElTopImage(refImage.current.offsetTop);
      if (refContent.current) setElTopContent(refContent.current.offsetTop);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [refImage, refContent]);

  // useEffect(() => {
  //   console.log(showElement);
  // }, [showElement]);

  useEffect(() => {
    document.addEventListener("scroll", checkScrollCondition, {
      passive: true,
    });

    return () => {
      document.removeEventListener("scroll", checkScrollCondition, {
        passive: true,
      });
    };
  });

  function CustomArrow(props) {
    const { className, style, onClick } = props;
    return (
      <span
        className={clsx(
          "border rounded-full flex items-center justify-center",
          className,
          styles.arrow
        )}
        style={{ ...style }}
        onClick={onClick}
      >
        <div className="flex w-full h-full  items-center justify-center">
          <img src={iconChevron} alt="icon-chevron" width={15} />
        </div>
      </span>
    );
  }

  const settings = useMemo(
    () => ({
      dots: true,
      dotsClass: clsx(
        "slick-dots slick-thumb paginationContainer",
        styles.paginationContainer
      ),
      infinite: true,
      autoplay: showElement ? true : false,
      speed: 500,
      focusOnSelect: true,
      nextArrow: <CustomArrow />,
      prevArrow: <CustomArrow />,
      customPaging: function (i) {
        return (
          <a>
            <h4 className="text-sm lg:text-3xl headline-remo">
              {data?.[i]?.year}
            </h4>
          </a>
        );
      },
    }),
    [data, showElement]
  );

  return (
    <motion.div
      ref={refImage}
      variants={variantContainer}
      initial="offScreen"
      whileInView={showElement ? "onScreen" : "offScreen"}
      className={clsx(classCustom, styles.sliderSlickJourney)}
    >
      <Slider {...settings} className={clsx(styles.sliderContainer)}>
        {data?.map((item, index) => (
          <div key={index} className={clsx(styles.sliderItem)}>
            <div className="flex flex-wrap items-center">
              <div
                className={clsx(
                  "w-full lg:w-1/2 mx-auto relative flex flex-col",
                  styles.imgContainer
                )}
              >
                <img src={item?.img} alt={`img-${item?.title}`} />
              </div>

              <motion.div
                ref={refContent}
                variants={variantContent}
                initial="offScreen"
                whileInView={showElContent ? "onScreen" : "offScreen"}
                className="p-4 w-full lg:w-1/2"
              >
                <h4
                  className={clsx(
                    "hidden lg:block text-3xl lg:text-5xl text-center lg:text-left headline-remo",
                    styles.textYellow
                  )}
                >
                  {item?.year}
                </h4>
                <h4 className="mt-2 headline-remo text-xl lg:text-3xl text-center lg:text-left">
                  {item?.title}
                </h4>
                <p className="mt-2 lg:text-xl text-center lg:text-left">
                  {item?.desc}
                </p>
              </motion.div>
            </div>
          </div>
        ))}
      </Slider>
    </motion.div>
  );
}
